import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {BackButton, Button, Container, Input, Text} from '../../../components/@FreeModel';
import Header from '../../../components/general/Header/Header';
import {useDispatch, useSelector} from "react-redux";
import {selectApplication, selectFederalClassifications} from "../../../db/selectors";
import {gql, Option, queryApplicationWithFederalClassifications, updateApplication} from "../../../db/model";
import {Box, InputLabel, MenuItem, Select} from "@mui/material";

const TaxInfoBusiness = (): React.ReactElement => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {applicationID} = useParams()
  const application = useSelector(selectApplication)
  const federalClassifications = useSelector(selectFederalClassifications)

  const [businessLegalName, setBusinessLegalName] = useState(application?.businessLegalName ?? '')
  const [federalClassification, setFederalClassification] = useState(application?.federalClassification?.type?.value ?? '');
  const [federalClassificationSubtype, setFederalClassificationSubtype] = useState(application?.federalClassification?.subtype?.value ?? '');
  const defaultSubtypes: Option[] = []
  const [subtypes, setSubTypes] = useState(defaultSubtypes)
  const [loaded, setLoaded] = useState(false);

  const isValid = businessLegalName !== '' && federalClassification !== '' && (federalClassification !== "LLC" || federalClassificationSubtype !== "")
  const subtypeRequired = subtypes.length > 0

  useEffect(() => {
    if (loaded) {
      return
    }

    // @ts-ignore
    dispatch(gql({
      query: queryApplicationWithFederalClassifications,
      variables: {
        federalClassificationGroupType: "Business",
        id: applicationID,
      },
      onSuccess: (data) => {
        setLoaded(true)
        setBusinessLegalName(data.application?.businessLegalName ?? '')
        setFederalClassification(data.application?.federalClassification?.type?.value ?? '')
        setFederalClassificationSubtype(data.application?.federalClassification?.subtype?.value ?? '')
        if (data?.federalClassifications) {
          for (let f of data.federalClassifications) {
            if (f.value === federalClassification) {
              if (f.subtypes && f.subtypes.length > 0) {
                setSubTypes(f.subtypes)
              }
              break
            }
          }
        }
      }
    }))

  }, [loaded, dispatch, applicationID, federalClassification, setBusinessLegalName, setFederalClassification, setLoaded]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // @ts-ignore
    dispatch(gql({
      query: updateApplication,
      variables: {
        id: applicationID,
        form: {
          businessLegalName: businessLegalName,
          federalClassification: {
            type: federalClassification,
            subtype: federalClassificationSubtype?.length > 0 ? federalClassificationSubtype : null
          },
        }
      },
      onSuccess: (_) => navigate(`/contractors/${applicationID}/tax-info/business/address`)
    }))
  };

  const handleOnChange = (federalClassification: string) => {
    setFederalClassification(federalClassification)
    for (let f of federalClassifications) {
      if (f.value === federalClassification) {
        if (f.subtypes && f.subtypes.length > 0) {
          setSubTypes(f.subtypes)
        } else {
          setSubTypes([])
          setFederalClassificationSubtype("")
        }
        break
      }
    }
  }

  return (
    <Container className="taxInfoBusiness">
      <Header title="Add Tax Info"/>
      <BackButton to={`/contractors/${applicationID}/tax-info`}/>

      <br/>

      <form onSubmit={handleSubmit}>
        <Text weight="semibold">What is your legal business name (as shown on your tax return)?</Text>

        <br/>

        <Input
          label="Legal Name"
          id="legal-name"
          type="text"
          value={businessLegalName}
          onChange={e => setBusinessLegalName(e.target.value)}
        />

        <InputLabel
          id="federal-tax-classification-label"
          size="small"
          variant="standard"
        >Federal Tax Classification</InputLabel>
        <Select
          id="federal-tax-classification"
          className="federal-tax-classification"
          variant="standard"
          label="Federal Tax Classification"
          labelId="federal-tax-classification-label"
          value={federalClassification}
          onChange={(e) => handleOnChange(e.target.value)}
        >
          {federalClassifications?.map(option => {
            return (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            )
          })}
        </Select>

        {subtypeRequired && <Box>
          <InputLabel
            id="federal-tax-classification-subtype-label"
            size="small"
            variant="standard"
          >Federal Tax Classification Subtype</InputLabel>
          <Select
            id="federal-tax-classification-subtype"
            className="federal-tax-classification"
            variant="standard"
            label="Federal Tax Classification Subtype"
            labelId="federal-tax-classification-subtype-label"
            value={federalClassificationSubtype}
            onChange={(e) => setFederalClassificationSubtype(e.target.value)}
            required={subtypeRequired}
          >
            {subtypes?.map(option => {
              return (
                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
              )
            })}
          </Select>
        </Box>
        }

        <br/>
        <br/>
        <br/>

        <Button disabled={!isValid}>Continue</Button>
      </form>
    </Container>
  );
};

export default TaxInfoBusiness;
